module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaW1nL3NoZW56aGVuLWhlYWRlci1iZy43MWM3N2E0LjcxYzc3YTQucG5nIjsKCgovLy8vLy8vLy8vLy8vLy8vLy8KLy8gV0VCUEFDSyBGT09URVIKLy8gLi9zcmMvYXNzZXRzL2ltYWdlcy9zaGVuemhlbi1oZWFkZXItYmcuNzFjNzdhNC5wbmcKLy8gbW9kdWxlIGlkID0gS3BCcgovLyBtb2R1bGUgY2h1bmtzID0gMTg="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shenzhen-header-bg.71c77a4.png
// module id = KpBr
// module chunks = 18